/**
 * @desc fulfilment
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.InPlanCreateRequestParamsDto, options?: any) {
  return updateResponse(
    http(URL + `/inPlan/fulfilment`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
